<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime podjetja *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.address"
          label="Ulica in hišna številka podjetja *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.address.required)"
        >
          <FormErrorsLine v-if="!$v.form.address.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.post_code"
          label="Poštna številka podjetja *"
          @blur="fillCity"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.post_code.required)"
        >
          <FormErrorsLine v-if="!$v.form.post_code.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.city"
          label="Mesto podjetja *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.city.required)"
        >
          <FormErrorsLine v-if="!$v.form.city.required" text="Polje je obvezno" />
        </FormErrors>
        <v-checkbox
          color="#0F998E"
          v-model="form.tax_bound"
          label="Zavezanec za ddv"
        ></v-checkbox>
        <v-text-field
          v-model="form.tax_number"
          label="Davčna številka podjetja *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.tax_number.required || !$v.form.tax_number.isTaxNumber)"
        >
          <FormErrorsLine v-if="!$v.form.tax_number.required" text="Polje je obvezno" />
          <FormErrorsLine v-if="!$v.form.tax_number.isTaxNumber" text="Davčna številka ni veljavna" />
        </FormErrors>
        <v-text-field
          v-model="form.register_number"
          label="Matična številka podjetja"
        ></v-text-field>
        <v-text-field
          v-model="form.account_number"
          label="Številka računa podjetja"
        ></v-text-field>
        <v-text-field
          v-model="form.contact"
          label="Kontakt"
        ></v-text-field>
        <v-btn type="submit" class="float-right" :disabled="!client.is_active">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import { postName } from '@/utils/postCodes'
import { isValidTaxNumber } from '@/utils/taxNumber'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    isChildCompany: {
      default: true,
      type: Boolean
    },
    client: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      form: {
        name: '',
        address: '',
        post_code: '',
        city: '',
        tax_bound: false,
        tax_number: '',
        register_number: '',
        account_number: '',
        contact: ''
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      address: {
        required
      },
      post_code: {
        required
      },
      city: {
        required
      },
      tax_number: {
        required,
        isTaxNumber: val => isValidTaxNumber(val)
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    fillCity () {
      this.form.city = postName(this.form.post_code)
    }
  },
  created () {
    this.form = { ...this.form, ...this.client }
  }
}
</script>
